import type { DistrictNcesId } from "@nimble/datamodel/types/ncesId";
import { useUrlDrawer } from "@nimble/react-state-hooks/use-url-drawer";
import { useCallback } from "react";

import DistrictJobDetailsDrawerContainer from "@/components/shared/jobs/district-job-details-drawer/district-job-details-drawer.container";
import {
  DISTRICT_JOB_DRAWER_PARAM,
  parseDistrictJobDrawerValue,
  toDistrictJobDrawerValue,
} from "@/components/shared/jobs/district-job-details-drawer/district-job-drawer-param";

export default function useDistrictJobDetailsURLDrawer() {
  const { isOpen, openDrawer, closeDrawer, value } = useUrlDrawer({
    paramName: DISTRICT_JOB_DRAWER_PARAM,
  });

  const openDistrictJobDetailsDrawer = useCallback(
    (jobId: string, districtNcesId: DistrictNcesId) => {
      openDrawer(toDistrictJobDrawerValue(districtNcesId, jobId));
    },
    [openDrawer],
  );

  const drawerTarget = value ? parseDistrictJobDrawerValue(value) : null;

  const content = drawerTarget && (
    <DistrictJobDetailsDrawerContainer
      jobId={drawerTarget.jobId}
      districtNcesId={drawerTarget.districtNcesId}
      onClose={closeDrawer}
    />
  );

  return {
    isOpen,
    content,
    openDistrictJobDetailsDrawer,
    closeDistrictJobDetailsDrawer: closeDrawer,
  };
}
